import React from 'react';
import styled, { keyframes } from 'styled-components';

const scaleAnimation = keyframes`
  0% {
    opacity: 0;
    transform: scale(1.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const drawCircleAnimation = keyframes`
  0% {
    stroke-dashoffset: 223;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const drawCheckAnimation = keyframes`
  0% {
    stroke-dashoffset: 44;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const fadeOutAnimation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Svg = styled.svg`
  animation: 0.6s ease-out both ${scaleAnimation};

  .successAnimationCircle {
    stroke-dasharray: 223 223;
    stroke: var(--green);
    animation:
      1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both ${drawCircleAnimation},
      0.3s linear 0.4s 1 both ${fadeOutAnimation};
  }

  .successAnimationCheck {
    stroke-dasharray: 45 60;
    stroke: var(--green);
    /* Using 'both' as fill mode ensures initial state is retained */
    animation:
      1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both ${drawCheckAnimation},
      0.3s linear 0.4s 1 both ${fadeOutAnimation};
  }

  .successAnimationResult {
    fill: var(--green);
    opacity: 0;
    animation: 0.3s linear 0.4s both ${fadeInAnimation};
  }
`;

type Props = {
  size?: number;
};

export default function SuccessAnimation({ size = 100 }: Props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 73 72"
      fill="none"
    >
      {/* Circle outline */}
      <circle
        className="successAnimationCircle"
        cx="36.5"
        cy="36"
        r="35.5"
        strokeWidth="4"
        strokeLinecap="round"
        fill="transparent"
      />
      {/* Check mark (tick) with thicker stroke */}
      <polyline
        className="successAnimationCheck"
        points="22,35 32,45 54,23"
        strokeWidth="7"
        strokeLinecap="round"
        fill="transparent"
      />
      {/* Final filled result */}
      <path
        className="successAnimationResult"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5 0C56.3788 0 72.5 16.1212 72.5 36C72.5 55.8788 56.3788 72 36.5 72C16.6212 72 0.5 55.8788 0.5 36C0.5 16.1212 16.6212 0 36.5 0ZM29.0241 47.6931L20.2105 38.8721C18.7089 37.3697 18.7086 34.9196 20.2105 33.4175C21.7126 31.9156 24.1736 31.925 25.6648 33.4175L31.8784 39.6359L47.3357 24.1786C48.8379 22.6764 51.2882 22.6764 52.7901 24.1786C54.2923 25.6805 54.2901 28.1329 52.7901 29.633L34.6012 47.8219C33.1012 49.3219 30.6487 49.324 29.1468 47.8219C29.1046 47.7797 29.0639 47.7368 29.0241 47.6931Z"
      />
    </Svg>
  );
}
